(ns minorodata.components.admin.core
  (:require
   ["lucide-react" :refer [Database FlaskConical MessageSquare Plug Shield Zap]
    :as lucide]
   [clojure.string :as string]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.admin.byol :as admin-byol]
   [minorodata.components.admin.drawers :as admin-drawers]
   [minorodata.components.admin.forms :as admin-forms]
   [minorodata.components.admin.vcs :refer [version-control-settings]]
   [minorodata.components.connections.drawers :as connections-drawers]
   [minorodata.components.connections.overview :as connections-overview]
   [minorodata.components.spinner.core :as spinner.core]
   [minorodata.utils :as minoro.utils]
   [re-posh.core :as re-posh]
   [react :as react]
   [reagent.core :as reagent]
   [ui.accordion]
   [ui.button :refer [button]]
   [ui.card :refer [card card-content card-description card-title]]
   [ui.chip :refer [chip]]
   [ui.fields :refer [switch]]
   [ui.page :refer [page-content page-controls page-header page-root
                    page-title]]
   [ui.table :refer [table tbody td th thead tr]]
   [ui.tabs :as tabs]
   [ui.typography :as typography]))


(defn page-tabs-config []
  (let [ai-settings? @(re-posh/subscribe [:unleash/is-enabled "fe.ai-chat"])]
    [{:value   :account
      :label   "Account"}
     {:value   :users
      :label   "Users"}
     {:value   :roles
      :label   "Roles"}
     {:value   :notification-preferences
      :label   "Notification preferences"}
     (when ai-settings?
       {:value   :ai-settings
        :label   "AI"})]))

(defn get-role-name
  [{:user-account/keys [role-id]}]
  (let [roles      (re-posh/subscribe [:users.subs/roles])]
    (some->> @roles
             (minoro.utils/find-first #(= (:role/id %) role-id))
             :role/name)))

(defn account-users [{:keys [set-drawer set-user]}]
  (let [current-user        @(re-posh/subscribe [:user/pull])
        admin-data          (re-posh/subscribe [:client-data/pull [:client-data/cid (:user/cid current-user)]])
        admin-data-loading? (re-posh/subscribe [:mold-http/loading? :users.api/fetch-admin-data-members])]
    (dispatch [:users.api/fetch-admin-data-members])
    (fn []
      [card {:class "w-full min-w-[1000px]"}
       [card-content
        [:header {:class "mb-2 flex justify-between items-center"}
         [card-title
          "Active users"
          (when @admin-data-loading?
            [spinner.core/spinner-lucide {:size 20 :class "inline-block ml-2"}])]
         [button {:variant  :secondary
                  :size     :small
                  :on-click #(set-drawer :new-user)
                  :class "-my-1"}
          "Add user"]]

        (when-not (empty? (:client-data/users @admin-data))
          [:div
           [table
            [thead
             [tr
              [th "Username"]
              [th "Login"]
              [th "Role"]
              [th "Auth"]
              [th {:class "text-right"} "Actions"]]]

            (into
             [tbody]
             (map (fn [{:user-account/keys
                        [id user-name login-name is-blocked is-sso] :as user}]
                    (let [role-name (get-role-name user)]
                      [tr
                       [td user-name]
                       [td login-name]
                       [td role-name]
                       [td
                        [chip {:variant (when is-sso :success)}
                         (if is-sso
                           "SSO"
                           "password")]]
                       [td
                        [:div {:class "flex justify-end"}
                         [button {:size     :small
                                  :variant  :link
                                  :on-click (fn []
                                              (set-user id)
                                              (set-drawer :edit-user))}
                          "Edit"]
                         (when-not is-sso
                           [button {:size     :small
                                    :variant  :link
                                    :on-click (fn []
                                                (set-user id)
                                                (set-drawer :change-password-user))}
                            (if is-blocked
                              "Unblock"
                              "Change password")])]]]))
                  (:client-data/users @admin-data)))]])]])))

(defn account-roles [{:keys [admin-data roles-data set-drawer set-role]}]
  (let [{:client-roles/keys [roles]} roles-data

        roles-data-loading? (re-posh/subscribe [:mold-http/loading? :users.api/fetch-roles])
        users               (:client-data/users admin-data)
        sorted-roles        (sort-by (comp clojure.string/lower-case :role/name) roles)]
    [card
     [card-content
      [:header {:class "flex items-center justify-between mb-2"}
       [card-title
        "Roles"
        (when @roles-data-loading?
          [spinner.core/spinner-lucide {:size 20 :class "inline-block ml-2"}])]

       [button {:variant  :secondary
                :size     :small
                :on-click #(set-drawer :new-role)
                :class "-my-1"}
        "Add role"]]

      (if (and (some? roles) (empty? roles))
        [:div "No rules found"]
        [:div
         [table

          [thead
           [tr
            [th "Role"]
            [th {:class "text-center"} "Users"]
            [th "Permissions"]
            [th {:class "text-right"} "Actions"]]]

          [tbody
           (for [{:role/keys [id permissions] :as role} sorted-roles]
             (let [num-of-read-permissions  (->> permissions (filter #(= "read" (name %))) count)
                   num-of-write-permissions (->> permissions (filter #(= "write" (name %))) count)
                   num-of-users             (->> users (filter #(= (:user-account/role-id %) (:role/id role))) count)
                   admin-role?              (contains? permissions :admin/all)
                   restricted-role?         (empty? permissions)]
               [tr {:key id}
                [td (:role/name role)]
                [td {:class "text-center"} num-of-users]
                [td (cond
                      restricted-role? "No permissions"
                      admin-role?      "Admin permissions"
                      :else            (str num-of-write-permissions " Editable, " num-of-read-permissions " Read-only"))]
                [td {:align "right"}
                 [button {:variant  :link
                          :size     :small
                          :disabled (or admin-role? restricted-role?)
                          :on-click (fn []
                                      (set-role id)
                                      (set-drawer :edit-role))}
                  "Edit"]]]))]]])]]))


(defn account-tab [{:keys [admin-data classes]}]
  [:div {:class "grid gap-4 w-2xl"}
   [card {:class "flex flex-col gap-8"}
    [card-content

     [card-title "Account settings"]
     [admin-forms/account-form
      {:admin-data admin-data
       :classes    classes}]]]

   [card
    [card-content
     [card-title "Warehouse and Filestore"]

     [:div {:class "flex gap-4 mt-4"}
      [:div {:class "flex-1"} [connections-overview/warehouses]]
      [:div {:class "flex-1"} [connections-overview/filestores]]]]]

   (when @(re-posh/subscribe [:unleash/is-enabled "fe.git-integration"])
     [card
      [card-content
       [card-title "Version control"]
       [:div {:class "mt-4"}
        [version-control-settings]]]])

   [:f> connections-drawers/drawers]])

(defn ai-setting [{:keys [icon title badge body note checked on-click disabled feature-flag]}]
  (when (or (not feature-flag)
            (and feature-flag
                 @(re-posh/subscribe [:unleash/is-enabled feature-flag])))
    [:article {:class ["flex items-start justify-between gap-4 py-4"
                     (when disabled "opacity-40")]}
   [:div {:class "flex min-w-0 gap-4 items-start"}
    [:div {:class "mt-1 flex h-10 w-10 shrink-0 p-1 items-center justify-center rounded-xl bg-kleene-success-background"}
     [:> icon {:class "text-kleene-text-success dark:text-kleene-primary-01" :size 20}]]
    [:div {:class "min-w-0"}
     [:div {:class "mb-2 flex flex-wrap items-center gap-3"}
      [typography/h2 {:class "tracking-tight"} title]
      [chip {:variant (if (= badge "Default") :main :secondary-border)}
       badge]]
     [:p {:class "mb-2 max-w-4xl leading-relaxed text-kleene-text-secondary"} body]
     [:p {:class "leading-relaxed text-kleene-text-secondary opacity-60 text-xs"} note]]]

   [:div {:class "shrink-0 pt-2 pr-2"}
    [switch {:checked checked
             :on-click on-click
             :disabled disabled}]]]))

(defn ai-settings []
  (let [settings @(re-posh/subscribe [:ai-settings/pull])
        ai-or-mcp-enabled? (or (:ai-settings/assistant-enabled settings)
                               (:ai-settings/mcp-enabled settings))
        sharing-items
        [{:icon MessageSquare
          :title "General Usage"
          :badge "Default"
          :body "Kleene AI operates in general usage mode. Users provide inputs and no platform context is shared unless explicitly shared with KAI."
          :note "No customer data is accessed or processed by the AI agent."
          :checked (:ai-settings/assistant-enabled settings)
          :on-click (fn [e]
                      (.preventDefault e)
                      (dispatch [:ai-settings/update {:ai-settings/assistant-enabled (not (:ai-settings/assistant-enabled settings))}])
                      (dispatch [:ai-chat/update-settings {:assistant-enabled (not (:ai-settings/assistant-enabled settings))}]))
          :disabled false}
         {:icon Plug
          :title "External AI Assistants (MCP)"
          :badge "Opt-in"
          :body "Connect Kleene to any MCP-compatible AI assistant, enabling models like Claude, ChatGPT, and other LLMs to access your Kleene instance and its context."
          :note "Each user still signs in individually, and the data-sharing preferences below apply to MCP access too."
          :checked (:ai-settings/mcp-enabled settings)
          :on-click (fn [e]
                      (.preventDefault e)
                      (dispatch [:ai-settings/update {:ai-settings/mcp-enabled (not (:ai-settings/mcp-enabled settings))}])
                      (dispatch [:ai-chat/update-settings {:mcp-enabled (not (:ai-settings/mcp-enabled settings))}]))
          :disabled false
          :feature-flag "fe.ai-mcp-setting"}
         {:icon Database
          :title "Share Warehouse Metadata"
          :badge "Opt-in"
          :body "Authorise Kleene to process your warehouse metadata — schemas, tables, columns, and relationships."
          :note "Required for the agent to help with transforms in context. No row-level data is accessed."
          :checked (:ai-settings/db-metadata-access settings)
          :on-click (fn [e]
                      (.preventDefault e)
                      (dispatch [:ai-settings/update {:ai-settings/db-metadata-access (not (:ai-settings/db-metadata-access settings))}])
                      (dispatch [:ai-chat/update-settings {:db-metadata-access (not (:ai-settings/db-metadata-access settings))}]))
          :disabled (not ai-or-mcp-enabled?)}
         {:icon FlaskConical
          :title "Sample Previews with Synthetic Data"
          :badge "Opt-in"
          :body "Kleene AI may fetch limited row samples solely to create Synthetic Data via AWS Bedrock while helping with transforms and pipelines."
          :note "Preserves data types, shape, and common formatting patterns (e.g. postcode format, timestamps)."
          :checked (:ai-settings/db-data-sampling settings)
          :on-click (fn [e]
                      (.preventDefault e)
                      (dispatch [:ai-settings/update {:ai-settings/db-data-sampling (not (:ai-settings/db-data-sampling settings))}])
                      (dispatch [:ai-chat/update-settings {:db-data-sampling (not (:ai-settings/db-data-sampling settings))}]))
          :disabled (not ai-or-mcp-enabled?)}
         {:icon Zap
          :title "Faster Sample Previews"
          :badge "Opt-in"
          :body "Kleene AI may fetch limited row samples and use it directly without modification."
          :note "Much faster than using Synthetic Data."
          :checked (:ai-settings/db-raw-data-sampling settings)
          :on-click (fn [e]
                      (.preventDefault e)
                      (dispatch [:ai-settings/update {:ai-settings/db-raw-data-sampling (not (:ai-settings/db-raw-data-sampling settings))}])
                      (dispatch [:ai-chat/update-settings {:db-raw-data-sampling (not (:ai-settings/db-raw-data-sampling settings))}]))
          :disabled (or (not ai-or-mcp-enabled?)
                        (not (:ai-settings/db-data-sampling settings)))}

         #_{:icon BrainCircuit
            :title "Transform Contextual Assistance"
            :badge "Opt-in"
            :body "Allow Kleene AI to read transform code and pipeline configuration to provide contextual code suggestions and debugging help."
            :note "The agent can reference your SQL/Python transforms when answering questions about errors or optimisations."}]]
    (react/useEffect
     (fn []

       (dispatch [:ai-chat/get-settings])

       (fn []))
     #js [])

    [:div {:class "p-2 gap-2 flex flex-col w-full max-w-3xl"}
     [:section {:class "relative border rounded-xs bg-kleene-background inline-flex flex-col gap-1 p-4"}

      [:header {:class "mb-1"}
       [:div {:class "mb-1 flex items-center gap-2"}
        [:div {:class "flex h-6 w-6 items-center justify-center"}
         [:> Shield {:class "text-kleene-text-success dark:text-kleene-primary-01"}]]
        [typography/h1 {:class "tracking-tight"}
         "Kleene AI — Data Sharing Preferences"]]
       [:p {:class "leading-relaxed text-kleene-text-secondary"}
        "Control what data Kleene AI can access when assisting your team. These are tenant-level settings that apply to every user in this workspace."]]

      (into
       [:section {:class "divide-y divide-solid"}]
       (map
        ai-setting
        sharing-items))

      (when @(re-posh/subscribe [:unleash/is-enabled "fe.ai-byol"])
        [:f> admin-byol/byol-section {:row      ai-setting
                                      :settings settings}])]]))



(defn page-manager []
  (let [open-drawer   (reagent/atom nil)
        selected-user (reagent/atom nil)
        selected-role (reagent/atom nil)
        close-drawer  #(reset! open-drawer nil)
        set-drawer    #(reset! open-drawer %)
        set-user      #(reset! selected-user %)
        set-role      #(reset! selected-role %)
        current-user  (re-posh/subscribe [:user/pull])
        admin-data    (re-posh/subscribe [:client-data/pull [:client-data/cid (:user/cid @current-user)]])
        roles-data    (re-posh/subscribe [:client-roles/pull [:client-roles/cid (:user/cid @current-user)]])]
    (fn []
      (let [{:keys [tab]} @(re-posh/subscribe [:app-route/prop :app-route/query])
            tab (or tab "account")]
        [:div {}
         ;; Main content
         [:div {:class (if (= "ai-settings" tab)
                         "block w-full"
                         "inline-block")}
          (case tab
            "account"
            [account-tab
             {:admin-data @admin-data}]

            "users"
            [account-users
             {:admin-data @admin-data
              :set-drawer set-drawer
              :set-user   set-user}]

            "roles"
            [account-roles
             {:admin-data @admin-data
              :roles-data @roles-data
              :set-drawer set-drawer
              :set-role   set-role}]

            "notification-preferences"
            [:<>
             [card
              [card-content
               [admin-forms/notification-preferences-form]]]
             (when @(re-posh/subscribe [:unleash/is-enabled "fe.notifications"])
               [card {:class "mt-4"}
                [card-content
                 [admin-forms/jobs-notification-preferences-form]]])]

            "ai-settings"
            [:f> ai-settings {:set-drawer set-drawer
                              :admin-data @admin-data}])]

         [admin-drawers/new-user
          {:open     (= :new-user @open-drawer)
           :on-close close-drawer}]
         [admin-drawers/edit-client-user
          {:open       (= :edit-user @open-drawer)
           :on-close   close-drawer
           :user-id    @selected-user
           :admin-data @admin-data
           :on-delete  (fn [id]
                         (set-user id)
                         (set-drawer :delete-user))}]
         [admin-drawers/edit-role
          {:open       (= :edit-role @open-drawer)
           :role-id    @selected-role
           :on-close   close-drawer
           :roles-data @roles-data}]
         [admin-drawers/new-role
          {:open       (= :new-role @open-drawer)
           :on-close   close-drawer}]
         [admin-drawers/change-client-user-password
          {:open       (= :change-password-user @open-drawer)
           :on-close   close-drawer
           :user-id    @selected-user
           :admin-data @admin-data}]
         [admin-drawers/delete-client-user
          {:open       (= :delete-user @open-drawer)
           :on-close   close-drawer
           :user-id    @selected-user
           :admin-data @admin-data}]]))))

(defn page-tabs [{:keys [disabled]}]
  (let [{:keys [tab]} @(re-posh/subscribe [:app-route/prop :app-route/query])]
    [tabs/tabs {:value           (or tab :account)
                :on-value-change #(dispatch [:app.events/navigate-query {:tab %}])
                :variant         :underlined
                :disabled        disabled
                :classes         {:list "border-b-0"}
                :tabs            (filter identity (page-tabs-config))}]))

(defn admin-page []
  (dispatch [:users.api/fetch-admin-data])
  (dispatch [:users.api/fetch-roles])
  (dispatch [:app.api/fetch-timezones])

  (dispatch [:connections.api/fetch-user-connectors])
  (dispatch [:connections.api/fetch-user-synchronizers])
  (dispatch [:connections.events/load-data])

  (fn []
    (let [admin-data-loading? @(re-posh/subscribe [:mold-http/loading? :users.api/fetch-admin-data])
          timezones-loading?  @(re-posh/subscribe [:mold-http/loading? :app.api/fetch-timezones])
          current-user        @(re-posh/subscribe [:user/pull])
          admin-data          @(re-posh/subscribe [:client-data/pull [:client-data/cid (:user/cid current-user)]])]
      [page-root
       [page-header {:style         {:top "-3.5rem"}
                     :content-props {:class "pb-0"}}
        [page-title "App settings"]
        [page-controls [page-tabs {:disabled (not (and (some? (:client-data/clientname admin-data)) (not timezones-loading?)))}]]]

       [page-content
        (cond
          (and (some? (:client-data/clientname admin-data))
               (not timezones-loading?))
          [page-manager]

          admin-data-loading?
          [:div {:class "m-6"}
           [spinner.core/spinner-lucide {:size 50}]]

          :else
          [card {:class "w-2xl"}
           [card-content
            [card-title "You don't have a client set up yet"]
            [card-description "Please fill in the form below before you can start adding users."]
            [admin-forms/new-client-form]]])]])))
